'use client';

import { Styles, css } from '@flipster/styled-system/css';
import { convertDate, formatDatetime, getTimezoneOffset } from '@flipster/utils/datetime';

import { useMounted } from '../misc/lifecycle/mount';

interface Props {
  value: Date | number | string | null | undefined;
  format?: string;
  isUTC?: boolean;
  withUTCText?: boolean;
  withTimezone?: boolean;
  css?: Styles;
}

export const Datetime = ({ value, format, isUTC, withUTCText, withTimezone, css: cssProps }: Props) => {
  const isMounted = useMounted();

  const date = convertDate(value);

  if (!isMounted || !date) return <span className={css(cssProps)}>-</span>;

  let suffix: string | null = null;
  if (isUTC && withUTCText) suffix = 'UTC';
  if (withTimezone) suffix = getTimezoneOffset();

  return (
    <time dateTime={date.toISOString()} translate='no' className={css({ wordBreak: 'keep-all' }, cssProps)}>
      {formatDatetime(date, { format, isUTC })}
      {suffix && <span>{` ${suffix}`}</span>}
    </time>
  );
};
